import React, {useEffect, useState} from "react";
import {NewVariationWrap} from "components/atoms/MenuManagement/AddVariation/AddAvriation.styles";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Button from "components/molecules/Button";
import {FaPlus} from "react-icons/fa";
import {MdDelete} from "react-icons/md";


const AddSubVariation = ({onClose, onSave, initialSubVariations = [], isEdit}) => {
    const [form] = useForm();
    const [formState, setFormState] = useState([{variationName: "", price: ""}]);

    useEffect(() => {
        if (isEdit && initialSubVariations) {
            const updatedState = initialSubVariations.map(item => ({
                subVariationName: item.subVariationName || item.variationName || "",
                price: item.price || "",
                calories: item.calories || ""
            }));
            setFormState(updatedState.length ? updatedState : [{subVariationName: "", price: "", calories: ""}]);

            const fieldValues = updatedState
                .map((item, ind) => ({
                    [`subVariationName${ind}`]: item.subVariationName || "",
                    [`price${ind}`]: item.price || "",
                    [`calories${ind}`]: item.calories || ""
                }))
                .reduce((acc, curr) => ({...acc, ...curr}), {});

            form.setFieldsValue(fieldValues);
        }
    }, [isEdit, initialSubVariations, form]);

    const handleSubmit = () => {
        // granular validation (optional)
        // transform to the shape you want stored (subVariationName -> subVariationName)
        const transformed = formState.map(it => ({
            subVariationName: it.subVariationName || it.variationName || "",
            price: it.price,
            calories: it.calories
        }));
        if (onSave) onSave(transformed);
        if (onClose) onClose();
    };

    const addFeilds = () => {
        setFormState(prevState => [...prevState, {subVariationName: "", price: "", calories: ""}]);
    };

    const handleFieldChange = (index, field, value) => {
        setFormState(prevState => prevState.map((item, i) => (i === index ? {...item, [field]: value} : item)));
        form.setFieldsValue({[`${field}${index}`]: value});
    };

    const removeVariation = index => {
        setFormState(prevState => prevState.filter((_, i) => i !== index));
    };

    return (
        <>
            <NewVariationWrap>

                <Form form={form} onSubmit={() => handleSubmit()} className="form-wrap">
                    {formState.map((item, ind) => (
                        <div key={ind}>
                           <div className="delete-btn">
                                <Button danger sm type="button" onClick={() => removeVariation(ind)}>
                                    <MdDelete />
                                    Delete
                                </Button>
                            </div>
                            <div className="user-fields">
                                <Form.Item
                                    label="Variation Name *"
                                    type="text"
                                    name={`subVariationName${ind}`}
                                    lg
                                    placeholder="Regular"
                                    $bgWhite
                                    value={item.subVariationName}
                                    onChange={e => handleFieldChange(ind, "subVariationName", e.target.value)}
                                    rules={[{required: true, message: "Name is required"}]}>
                                    <Field />
                                </Form.Item>

                                <Form.Item
                                    label="Enter Price *"
                                    type="number"
                                    min={0}
                                    step="any"
                                    name={`price${ind}`}
                                    lg
                                    placeholder="$5"
                                    $bgWhite
                                    value={item.price}
                                    onChange={e => handleFieldChange(ind, "price", e.target.value)}
                                    rules={[{required: true, message: "Price is required"}]}>
                                    <Field />
                                </Form.Item>
                            </div>
                                <Form.Item
                                    label="Calories (per serving)"
                                    type="number"
                                    min={0}
                                    step="any"
                                    name={`calories${ind}`}
                                    lg
                                    placeholder="e.g., 250 or 23.5"
                                    $bgWhite
                                    value={item.calories}
                                    onChange={e => handleFieldChange(ind, "calories", e.target.value)}
                                    rules={[{required: false, message: "Calories is required"}]}>
                                    <Field suffix="kcal" />
                                </Form.Item>
                        </div>
                    ))}

                    <div className="btn-holder">
                        <div className="add-btn">
                            <Button lg gray type="button" onClick={addFeilds}>
                                <FaPlus />
                                Add Variation
                            </Button>
                        </div>
                        <div className="save-btn">
                            <Button lg type="submit">
                                Save Variation
                            </Button>
                        </div>
                    </div>
                </Form>
            </NewVariationWrap>
        </>
    );
};
export default AddSubVariation;
